import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import {
  ControlValueAccessor,
  FormControl,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { IStickCricketGame } from '../stick-cricket-game.interface';
import { StickCricketGameCoreService } from '../stick-cricket-game-core.service';

@Component({
  selector: 'app-stick-cricket-game-selector',
  templateUrl: './stick-cricket-game-selector.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => StickCricketGameSelectorComponent),
    },
  ],
})
export class StickCricketGameSelectorComponent
  implements OnInit, OnDestroy, ControlValueAccessor
{
  private _unsubscribe$ = new Subject<void>();

  @Input()
  hint = '';

  @Input()
  isEmptySelectable = false;

  @Output() itemSelected = new EventEmitter<IStickCricketGame>();

  ctrl: FormControl = new FormControl();

  constructor(
    public stickCricketGameCoreService: StickCricketGameCoreService,
  ) {}

  ngOnInit(): void {
    this.ctrl.valueChanges
      .pipe(takeUntil(this._unsubscribe$))
      .subscribe((value: string) => {
        this.itemSelected.emit();
        this.onChange(value);
      });
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onChange: any = (): void => {};
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onTouch: any = (): void => {};

  ngOnDestroy(): void {
    this._unsubscribe$.next();
    this._unsubscribe$.complete();
  }

  writeValue(v: string): void {
    this.ctrl.setValue(v);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    if (isDisabled) {
      this.ctrl.disable();
    } else {
      this.ctrl.enable();
    }
  }

  refresh(): void {
    this.stickCricketGameCoreService.refresh(true);
  }
}
